module.exports = __webpack_public_path__ + "img/guigeliao3.ff6f2a0e.jpg";